module.exports = "/static/assets/ef9ad7d985162ed527aca819ad691267.png";